/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Elsewhere_FaqInputs */

const en_contact_elsewhere_faq = /** @type {(inputs: Contact_Elsewhere_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the questions people ask`)
};

const lv_contact_elsewhere_faq = /** @type {(inputs: Contact_Elsewhere_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izlasīt biežāk uzdotos jautājumus`)
};

/**
* | output |
* | --- |
* | "Read the questions people ask" |
*
* @param {Contact_Elsewhere_FaqInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_elsewhere_faq = /** @type {((inputs?: Contact_Elsewhere_FaqInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Elsewhere_FaqInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_elsewhere_faq(inputs)
	return en_contact_elsewhere_faq(inputs)
});